import LegendItem from "../LegendItem/LegendItem"
import { legendRouter } from "../../services/iconRouter";


const MapLegend = () => {

    return (
        <div style={{
            height: "auto",
            width: "95%",
            color: "white",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            gap: "5px",
            marginBottom: "5px"
        }}>
            {legendRouter.map((item, index) => (
                <LegendItem 
                    key={index}
                    src={item.src}
                    label={item.label}
                />
            ))}
        </div>
    )
}

export default MapLegend